/** Anchor used by the hero "Hire Now" CTA to reach the services grid. */
export const PROVIDER_SERVICES_ANCHOR_ID = 'provider-services';
